import { render, staticRenderFns } from "./disability.vue?vue&type=template&id=ec9dec58&scoped=true&"
import script from "./disability.vue?vue&type=script&lang=js&"
export * from "./disability.vue?vue&type=script&lang=js&"
import style0 from "./disability.vue?vue&type=style&index=0&id=ec9dec58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9dec58",
  null
  
)

export default component.exports